export const LOADING = 'loading';
export const LOADING_END = "LOADING_END";
export const MESSAGE = 'message';
export const ERROR = 'error';

